module.exports = __webpack_public_path__ + "static/media/HouseSmartVideoBuiltSmart.1adf1c87.jpg";